import React from 'react'
import { FormattedMessage } from 'react-intl'
import svg from 'assets/svg'
//import { fontSize } from 'assets/themes/theme-default'
import { SECTIONS, AREA, CirlceSize } from './constants'

const fontSize = {
  base: '0.938rem', //15px
  big: '4.1176rem',
  lgXxl: '2.313rem', //34px
  lgXl: '1.938rem', //29px
  lgSm: '1.8rem', //27px
  lgXs: '1.533rem', //23px
  lgXxs: '1.333rem', //20px
  lg: '1.133rem', //17px
  sm: '0.933rem', //14px
  xs: '0.8rem', //12px
  xxs: '0.733rem' //11px
}

const intialDefaultsViews = [
  {
    id: AREA.FRONT,
    label: <FormattedMessage id="tradeIn-defaults-view-1" />,
    svg: svg.defaults_front,
    zones: [
      {
        id: SECTIONS.ROOF,
        svg: svg.defaults_front_roof,
        decorator: {
          circle: {
            cx: '230',
            cy: '8',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.LEFT_WING_MIRROR,
        svg: svg.defaults_front_left_mirror,
        decorator: {
          circle: {
            cx: '455',
            cy: '105',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.RIGHT_WING_MIRROR,
        svg: svg.defaults_front_right_mirror,
        decorator: {
          circle: {
            cx: '5',
            cy: '105',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.FRONT_HOOD,
        svg: svg.defaults_front_hood,
        decorator: {
          circle: {
            cx: '230',
            cy: '160',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.FRONT_WINDSHIELD,
        svg: svg.defaults_front_windshield,
        decorator: {
          circle: {
            cx: '230',
            cy: '70',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.FRONT_RIGHT_HEADLIGHTS,
        svg: svg.defaults_front_right_headlight,
        decorator: {
          circle: {
            cx: '70',
            cy: '170',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.FRONT_LEFT_HEADLIGHTS,
        svg: svg.defaults_front_left_headlight,
        decorator: {
          circle: {
            cx: '390',
            cy: '170',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.FRONT_BUMPER,
        svg: svg.defaults_front_bumper,
        decorator: {
          circle: {
            cx: '230',
            cy: '245',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      }
    ]
  },
  {
    id: AREA.BACK,
    label: <FormattedMessage id="tradeIn-defaults-view-2" />,
    svg: svg.defaults_back,
    zones: [
      {
        id: SECTIONS.ROOF,
        svg: svg.defaults_back_roof,
        decorator: {
          circle: {
            cx: '230',
            cy: '8',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.LEFT_WING_MIRROR,
        svg: svg.defaults_back_left_mirror,
        decorator: {
          circle: {
            cx: '5',
            cy: '105',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.RIGHT_WING_MIRROR,
        svg: svg.defaults_back_right_mirror,
        decorator: {
          circle: {
            cx: '455',
            cy: '105',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.BACK_WINDSHIELD,
        svg: svg.defaults_back_windshield,
        decorator: {
          circle: {
            cx: '230',
            cy: '60',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.BACK_TRUNK,
        svg: svg.defaults_back_trunk,
        decorator: {
          circle: {
            cx: '230',
            cy: '160',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.BACK_RIGHT_HEADLIGHTS,
        svg: svg.defaults_back_right_headlight,
        decorator: {
          circle: {
            cx: '378',
            cy: '133',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.BACK_LEFT_HEADLIGHTS,
        svg: svg.defaults_back_left_headlight,
        decorator: {
          circle: {
            cx: '82',
            cy: '133',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      },
      {
        id: SECTIONS.BACK_BUMPER,
        svg: svg.defaults_back_bumper,
        decorator: {
          circle: {
            cx: '230',
            cy: '245',
            r: CirlceSize.FRONT_BACK,
            fontSize: fontSize.lgXxs
          }
        }
      }
    ]
  },
  {
    id: AREA.RIGHT_SIDE,
    label: <FormattedMessage id="tradeIn-defaults-view-3" />,
    svg: svg.defaults_side,
    zones: [
      {
        id: SECTIONS.FRONT_RIGHT_RIM,
        svg: svg.defaults_side_front_rim,
        decorator: {
          circle: {
            cx: '-195',
            cy: '260',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_RIGHT_RIM,
        svg: svg.defaults_side_back_rim,
        decorator: {
          circle: {
            cx: '-770',
            cy: '260',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.FRONT_RIGHT_DOOR,
        svg: svg.defaults_side_front_door,
        decorator: {
          circle: {
            cx: '-400',
            cy: '180',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_RIGHT_DOOR,
        svg: svg.defaults_side_back_door,
        decorator: {
          circle: {
            cx: '-610',
            cy: '180',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BOTTOM_RIGHT_DOOR,
        svg: svg.defaults_side_door_bottom,
        decorator: {
          circle: {
            cx: '-510',
            cy: '280',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_RIGHT_WING,
        svg: svg.defaults_side_back_wing,
        decorator: {
          circle: {
            cx: '-800',
            cy: '140',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.FRONT_RIGHT_WING,
        svg: svg.defaults_side_front_wing,
        decorator: {
          circle: {
            cx: '-205',
            cy: '145',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      }
    ]
  },
  {
    id: AREA.LEFT_SIDE,
    label: <FormattedMessage id="tradeIn-defaults-view-4" />,
    svg: svg.defaults_side,
    zones: [
      {
        id: SECTIONS.FRONT_LEFT_RIM,
        svg: svg.defaults_side_front_rim,
        decorator: {
          circle: {
            cx: '195',
            cy: '260',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_LEFT_RIM,
        svg: svg.defaults_side_back_rim,
        decorator: {
          circle: {
            cx: '770',
            cy: '260',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.FRONT_LEFT_DOOR,
        svg: svg.defaults_side_front_door,
        decorator: {
          circle: {
            cx: '400',
            cy: '180',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_LEFT_DOOR,
        svg: svg.defaults_side_back_door,
        decorator: {
          circle: {
            cx: '610',
            cy: '180',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BOTTOM_LEFT_DOOR,
        svg: svg.defaults_side_door_bottom,
        decorator: {
          circle: {
            cx: '510',
            cy: '280',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.BACK_LEFT_WING,
        svg: svg.defaults_side_back_wing,
        decorator: {
          circle: {
            cx: '800',
            cy: '140',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      },
      {
        id: SECTIONS.FRONT_LEFT_WING,
        svg: svg.defaults_side_front_wing,
        decorator: {
          circle: {
            cx: '208',
            cy: '145',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      }
    ]
  },
  {
    id: SECTIONS.SADDLERY,
    label: <FormattedMessage id="tradeIn-defaults-view-6" />,
    svg: null,
    zones: [
      {
        id: SECTIONS.SADDLERY,

        decorator: {
          circle: {
            cx: '207',
            cy: '270',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      }
    ]
  },
  {
    id: SECTIONS.OTHER,
    label: <FormattedMessage id="tradeIn-defaults-view-5" />,
    svg: null,
    zones: [
      {
        id: SECTIONS.OTHER,

        decorator: {
          circle: {
            cx: '207',
            cy: '270',
            r: CirlceSize.SIDES,
            fontSize: fontSize.lgSm
          }
        }
      }
    ]
  }
]

export default intialDefaultsViews
